import React, {forwardRef} from 'react';
import {AnimatedOnScroll} from 'react-animated-css-onscroll';

const FadeInUp = forwardRef((props, ref) => (
    <AnimatedOnScroll animationIn="bounceInUp" {...props} ref={ref}>
        {props.children}
    </AnimatedOnScroll>
));

export default FadeInUp;